import { faJava, faNodeJs } from '@fortawesome/fontawesome-free-brands';

export const projects = [
  {
    icon: faNodeJs,
    name: 'Immoforce & Internal services',
    url: 'https://www.mcmakler.de',
  },
  { icon: faNodeJs, name: 'EduTerra.pro', url: 'https://eduterra.pro' },
  { icon: faNodeJs, name: 'ProStore', url: 'https://prostore.business/' },
  { icon: faNodeJs, name: 'my.rfei.ru', url: 'https://my.rfei.ru' },
  { icon: faNodeJs, name: 'artfit.club' },
  { icon: faJava, name: 'savant.pro', url: 'https://ru.savant.pro/' },
  { icon: faJava, name: 'eduarea.com', url: 'http://ru.eduarea.com/' },
  { icon: faJava, name: 'rfei.ru', url: 'https://rfei.ru' },
  { icon: faJava, name: 'circumflex', url: 'http://circumflex.ru/' },
];
